function handleInput(event, previousValue, setFunction, overwriteState = false) {
    const { target } = event;
    const variable = target.name;
    const inputIsACheckbox = target.type === "checkbox";
    const value = inputIsACheckbox ? target.checked : target.value;
    // If target state is an object, only change part of the state unless told to overwrite
    setFunction(typeof previousValue === "object" && !overwriteState ? { ...previousValue, [variable]: value } : value);
}
function quizSelectLogic(val, multi, answer) {
    // Returns the resulting answer array when a val is clicked
    let answer_copy = answer;
    if (multi && val !== "None") {
        // Remove none if it's in there
        const index = answer_copy.indexOf(val);
        if (index > -1) {
            // it is in the array
            answer_copy.splice(index, 1);
        }
        else {
            // it was not in the array. Add it
            answer_copy.push(val);
            const noneindex = answer_copy.indexOf("None");
            if (noneindex > -1) {
                // it is in the array
                answer_copy.splice(noneindex, 1);
            }
        }
    }
    else {
        answer_copy = [val];
    }
    return answer_copy;
}
const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
function areObjectsEqual(cart1, cart2) {
    for (const elem in cart1) {
        if (elem in cart2) {
            if (cart1[elem] != cart2[elem]) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
}
function areObjectsEqualAsStrings(cart1, cart2) {
    return JSON.stringify(cart1) === JSON.stringify(cart2);
}
// include feet param to convert from feet/inches to just inches
// set feet param to 0 to convert inches to feet/inches
const heightConverter = (feet, inches) => {
    if (isNaN(Number(feet)) || Number(feet) === 0) {
        return inches;
    }
    if (isNaN(Number(inches)) && Number(feet) >= 0) {
        return parseInt(feet) * 12;
    }
    if (Number(feet) > 0) {
        const feetToInches = Number(feet) * 12;
        return feetToInches + parseInt(inches);
    }
    const calculatedFeet = Math.floor(parseInt(inches) / 12);
    const calculatedInches = Number(inches) % 12;
    return [calculatedFeet, calculatedInches];
};
function sumObjVals(obj) {
    let sum = 0;
    for (const el in obj) {
        if (obj.hasOwnProperty(el)) {
            sum += parseFloat(obj[el]);
        }
    }
    return sum;
}
const convertMilitaryToAmPm = (hours) => {
    if (hours < 12) {
        return {
            formattedHour: hours,
            amPm: "am",
        };
    }
    if (hours === 12) {
        return {
            formattedHour: hours,
            amPm: "pm",
        };
    }
    return {
        formattedHour: hours - 12,
        amPm: "pm",
    };
};
const parseDateTime = (dateTime) => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const date = new Date(dateTime);
    return {
        day: days[date.getDay()],
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        date: date.getDate(),
        hour: date.getHours(),
        minutes: date.getMinutes(),
    };
};
const lbToKG = (lbs) => {
    const nearKgs = Number(lbs) * 0.45359237;
    const kgs = Math.round(nearKgs);
    return kgs;
};
const kgToLb = (kgs) => {
    const nearLbs = Number(kgs) * 2.20462262;
    const lbs = Math.round(nearLbs);
    return lbs;
};
const ftInToMCm = (feet, inches) => {
    const cmTotal = Number(feet) * 30.48 + Number(inches) * 2.54;
    const m = Math.floor(cmTotal / 100);
    const cm = Math.round(cmTotal - m * 100);
    return [m, cm];
};
const mCmToFtIn = (m, cm) => {
    const allCms = Number(cm) + Number(m) * 100;
    const realFeet = (allCms * 0.393701) / 12;
    const feet = Math.floor(realFeet);
    const inches = Math.round((realFeet - feet) * 12);
    return [feet, inches];
};
const ftToCm = (feet) => {
    const cmTotal = Math.round(Number(feet) * 30.48);
    return cmTotal;
};
const mToIn = (m) => {
    const allCms = Number(m) * 100;
    const inches = Math.round(allCms * 0.393701);
    return inches;
};
const cmToIn = (cm) => {
    const inches = Math.round(Number(cm) * 0.393701);
    return inches;
};
const inToCm = (inches) => {
    const cmTotal = Math.round(Number(inches) * 2.54);
    return cmTotal;
};
const cmToMCm = (cm) => {
    const allM = Math.floor(Number(cm) / 100);
    const allCm = Number(cm) - (allM * 100);
    return [allM, allCm];
};
function createMarkup(elem) {
    return { __html: elem };
}
function convertPricingForStripe(data) {
    return data
        .map((elem) => {
        const label = elem.line_item_name;
        if (label !== "This shipment") {
            let value = 0;
            if (elem.line_item_price !== "Free") {
                const price = parseFloat(elem.line_item_price.replace("$", "")) * 100;
                value = Math.round(parseInt(price.toString(), 10));
            }
            const line_item = { label, amount: value };
            return line_item;
        }
        return null;
    })
        .filter((item) => item !== null);
}
const productForHero = (products) => {
    if (products.filter((item) => item.is_in_cart).length === 3 ||
        products.filter((item) => item.is_in_cart).length === 0) {
        return { ...products[0] };
    }
    return { ...products.find((item) => item.is_in_cart === false) };
};
function isJson(item) {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
        value = JSON.parse(value);
    }
    catch (e) {
        return false;
    }
    return typeof value === "object" && value !== null;
}
export { isJson, mToIn, cmToIn, ftToCm, inToCm, cmToMCm, lbToKG, kgToLb, ftInToMCm, mCmToFtIn, handleInput, capitalizeFirstLetter, areObjectsEqual, quizSelectLogic, areObjectsEqualAsStrings, heightConverter, sumObjVals, parseDateTime, convertMilitaryToAmPm, createMarkup, convertPricingForStripe, productForHero, };
